import React from 'react'

import {ListDocs} from '../../modules'

export const ListDocPage = () => {
  return <ListDocs />
}
